var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" 昆山云鲲网络科技有限公司 版权所有 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("苏ICP备2022010226号")]),_c('router-link',{attrs:{"to":"/about","target":"_blank"}},[_vm._v("关于我们")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }